let heading = [
    {
        title: 'Basic Details',
        // subTitle: 'Please provide the following details to continue'
    },

    //Only Thiis Object is not included in side panel list in detail register form
    {
        title: 'Address',
        // subTitle: 'Please provide the following details to continue'
    },
    {
        title: 'Manyata Details',
        // subTitle: 'Please provide the following details to continue'
    },
    {
        title: 'Infrastructure Details',
        // subTitle: 'Please provide the following details to continue'
    },
    // {
    //     title: 'Other Details',
    //     // subTitle: 'Please provide the following details to continue'
    // },
    // {
    //     title: 'Infrastructure Availability',
    //     // subTitle: 'Please provide the following details to continue'
    // },
    {
        title: 'Statutory Registrations',
        subTitle: 'Select yes to the ones that you possess/have'
    },
    {
        title: 'Staff Details',
        // subTitle: 'Please provide the following details to continue'
    },
    {
        title: 'Accreditation Certificates',
        // subTitle: 'Please provide the following details to continue'
    },
    {
        title: 'Facility Referral',
        // subTitle: 'Please provide the following details to continue'
    },
    // {
    //     title: 'Purchased Information',
    //     // subTitle: 'Please provide the following details to continue'
    // }
]

// For every card/ section, make a new array of object.
let inputDataList = [
    [
        {
            label: "Registered Email ID",
            type: "email",
            controllerName: "email",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Registered Email ID",
            errorMsg: "email",
            isDisable: true,
        },
        {
            label: "Full Registered Name of Hospital/Facility",
            type: "text",
            controllerName: "facility_name",
            required: true,
            valueType: "text",
            hide: false,
            placeholder: "Full Regisestered Name of Hospital/Facility",
            errorMsg: "Name Of Hospital",
        },

        // Salutation
        // {
        //     label: "",
        //     type: "",
        //     controllerName: "facility_salutation",
        //     required: false,
        //     valueType: "",
        //     hide: true,
        //     placeholder: "",
        //     errorMsg: "",
        // },
        {
            label: "Name Of The Facility Owner",
            type: "text",
            controllerName: "facility_owner_name",
            required: true,
            valueType: "text",
            hide: false,
            placeholder: "Name Of The Facility Owner",
            errorMsg: "Facility Owner Name",
        },
        {
            label: "Contact Number Of The Facility Owner",
            type: "number",
            controllerName: "facility_owner_mobile",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Contact Number Of The Facility Owner",
            errorMsg: "Facility Contact No.",
        },
    ],
    [
        {
            label: "Pincode",
            type: "number",
            controllerName: "pincode",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Pincode",
            errorMsg: "Pincode",
        },
        {
            label: "State",
            type: "text",
            controllerName: "state_name",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "State",
            errorMsg: "state",
            isDisable: true,
        },
        {
            label: "District",
            type: "text",
            controllerName: "district_name",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "District",
            errorMsg: "district",
            isDisable: true,
        },
        {
            label: "Block",
            type: "text",
            controllerName: "block_name",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Region",
            errorMsg: "region",
            isDisable: true,
        },
        {
            label: "Detailed Address Of Facility",
            type: "text",
            controllerName: "address",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Detailed Address Of Facility",
            maxlength: "100",
            errorMsg: "Detailed Address",
        },
    ],
    [
        {
            label: "Email Of Manyata Point Of Contact",
            type: "email",
            controllerName: "email_user_manyata",
            required: true,
            valueType: "email",
            hide: false,
            placeholder: "Email Of Manyata Point Of Contact",
            errorMsg: "Email For Manyata Point Of Contact",
            isDisable: false,
        },
        {
            label: "Mobile Number Of Manyata Point Of Contact",
            type: "number",
            controllerName: "mobile",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Mobile Number Of Manyata Point Of Contact",
            errorMsg: "Contact No. For Manyata Point Of Contact",
        },
        {
            label: "How Did You Find Out About Manyata?",
            type: "singleSelect",
            option: [
                { name: 'Social Media', value: '1' },
                { name: 'Referred by a Manyata CSE/QI provider', value: '2' },
                { name: 'From another OBGYN/Hospital', value: '3' },
                { name: 'Event', value: '4' },
                { name: 'Other', value: '5' }
            ],
            controllerName: "find_manyata",
            required: true,
            valueType: "string",           // Value type string means able to enter alpha-numeric
            hide: false,
            placeholder: "How Did You Find Out About Manyata?",
            errorMsg: "How Did You Know About Manyata",
        },
        // {
        //     label: "Referring CSE Name",
        //     type: "text",
        //     controllerName: "cse_name",
        //     required: true,
        //     valueType: "string",
        //     hide: true,
        //     placeholder: "Referring CSE Name",
        //     errorMsg: "Referring CSE Name",
        // },
        {
            label: "Referring CSE Name",
            type: "singleSelect",
            option: [
                // { name: 'Exclusive Maternity', value: '1' },
                // { name: 'Multispeciality', value: '2' },
                // { name: 'Other', value: '3' },
            ],
            // controllerName: "cse_name",
            controllerName: "ref_cse_id",
            required: true,
            valueType: "string",
            hide: true,
            placeholder: "Referring CSE Name",
            errorMsg: "Referring CSE Name",
        },
        {
            label: "Please Specify",
            type: "text",
            controllerName: "other",
            required: true,
            valueType: "string",
            hide: true,
            placeholder: "Please Specify",
            errorMsg: "text",
        },

    ],
    [
        {
            label: "Type Of Hospital",
            type: "singleSelect",
            option: [
                { name: 'Exclusive Maternity', value: '1' },
                { name: 'Multispeciality', value: '2' },
                { name: 'Other', value: '3' },
            ],
            controllerName: "hospital_type",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Type Of Hospital",
            errorMsg: "Type Of Hospital",
        },
        {
            label: "Is Your Hospital / Facility Registered On The NHP Portal?",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_hospital_reg_nhp",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Is Your Hospital / Facility Registered On The NHP Portal?",
            errorMsg: "",
        },
        {
            label: "If Registered (Yes), Please Share Your NHP-ID Number",
            type: "number",
            controllerName: "nhp_id",
            required: true,
            valueType: "number",
            hide: true,
            placeholder: "If Registered (Yes), Please Share Your NHP-ID Number",
            errorMsg: "NHP-ID Number",
        },
        // {
        //     label: "If registered (Yes), Please share your NHP-ID number",
        //     type: "text",
        //     controllerName: "nhp_id",
        //     required: false,
        //     valueType: "string",
        //     hide: true,
        //     placeholder: "If registered (Yes), Please share your NHP-ID number",
        //     // parent: { parentName: "is_hospital_reg_nhp", value: "1" },
        //     errorMsg: "NHP-ID number",
        // },
        {
            label: "Number Of Beds In Your Facility",
            type: "singleSelect",
            option: [
                { name: '< 6 beds', value: 1, id: 1 },
                { name: '6 to 20 beds', value: 2, id: 2 },
                { name: '20 to 50 beds', value: 3, id: 3 },
                { name: '50 to 100 beds', value: 4, id: 4 },
                { name: '100 to 300 Beds', value: 5, id: 5 },
                { name: '>300', value: 6, id: 6 },
            ],
            controllerName: "num_bed_facility",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Number Of Beds In Your Facility",
            errorMsg: "No. Of Beds In Your Facility",
        },
        {
            label: "Number Of OBGYN Beds In Your Facility",
            type: "singleSelect",
            controllerName: "num_obgyn_bed",
            option: [
                { name: '< 6 beds', value: 1, id: 1 },
                { name: '6 to 20 beds', value: 2, id: 2 },
                { name: '20 to 50 beds', value: 3, id: 3 },
                { name: '50 to 100 beds', value: 4, id: 4 },
                { name: '100 to 300 Beds', value: 5, id: 5 },
                { name: '>300', value: 6, id: 6 },
            ],
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Number Of OBGYN Beds In Your Facility",
            errorMsg: "No. Of OBGYN Beds In Your Facility ",
            isDisable: true,
        },
        {
            label: "Average Number Of Deliveries Per Month",
            type: "singleSelect",
            option: [
                { name: '> 5', value: 1, id: 1 },
                { name: '>5 to <15', value: 2, id: 2 },
                { name: '>15 to <20 ', value: 3, id: 3 },
                { name: '>20 to <50', value: 4, id: 4 },
                { name: '>50', value: 5, id: 5 },
            ],
            controllerName: "avg_num_delivery_month",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Average Number Of Deliveries Per Month",
            errorMsg: "Average No. Of Deliveries Per Month",
            isDisable: false,
        },
        {
            label: "Practicing OBGYN in your facility is/are FOGSI member(s)?",
            type: "radio",
            option: [{ name: 'Yes', value: '1' }, { name: 'No', value: '2' },],
            controllerName: "practicing_obg",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Practicing OBGYN in your facility is/are FOGSI member(s)?",
            errorMsg: "",
        },
        {
            label: "Is Your Facility Is Registered With The DHA (District Health Authority)?",
            type: "radio",
            option: [{ name: 'Yes', value: '1' }, { name: 'No', value: '2' },],
            controllerName: "facility_reg_dha",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Is Your Facility Is Registered With The DHA (District Health Authority)?",
            errorMsg: "",
        },
        {
            label: "Casualty/Minor OT",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "casuality_ot",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Casualty/Minor OT",
            errorMsg: "",
        },
        {
            label: "Laboratory",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_laboratory",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Laboratory",
            errorMsg: "",
        },
        {
            label: "Sterilization/CSSD",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_staratization",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Sterilization/CSSD",
            errorMsg: "",
        },
    ],
    [
        {
            label: "CEA (Clinical Establishment Act)",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_cea",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "CEA (Clinical Establishment Act)",
            errorMsg: "",
        },
        {
            label: "Shops And Establishment ACT",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "shop_estb_act",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Shops And establishment act",
            errorMsg: "",
        },
        {
            label: "MOU With BMW Collecting Agency",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "mou_with_coll_agency",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "MOU With BMW Collecting Agency",
            errorMsg: "",
        },
        {
            label: "License From State Pollution Control Board",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_lisc_spcb",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "License From State Pollution Control Board",
            errorMsg: "",
        },
        {
            label: "PCPNDT Registration",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_pcpndt_reg",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "PCPNDT Registration",
            errorMsg: "",
        },

    ],
    [
        {
            label: "Number Of OBGYN Doctors",
            type: "number",
            controllerName: "num_obgyn_doctor",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Number Of OBGYN Doctors",
            errorMsg: "No. Of OBGYN Doctors",
        },
        {
            label: "Number Of Nurses (ANM/Others)",
            type: "number",
            controllerName: "num_nurse_anm",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Number Of Nurses (ANM/Others)",
            errorMsg: "No. Of Nurses (ANM/Others)",
        },
        {
            label: "Number Of Nurses (GNM/BSC)",
            type: "number",
            controllerName: "num_nurse_gnm",
            required: true,
            valueType: "number",
            hide: false,
            placeholder: "Number Of Nurses (GNM/BSC)",
            errorMsg: "No. Of Nurses (GNM/BSC)",
        },
    ],
    [
        {
            label: "NABH",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_nabh",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "NABH",
            errorMsg: "",
        },
        {
            label: "PMJAY",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "is_pmjy",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "PMJAY",
            errorMsg: "",
        },
        {
            label: "Any Other Accreditation Certificates",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "other_accred_certificate",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Any Other Accreditation Certificates",
            errorMsg: "",
        },
        {
            label: "Please Specify If Any Other Accreditation Certificates",
            type: "text",
            controllerName: "specify_accred_certificate",
            required: true,
            valueType: "text",
            hide: true,
            placeholder: "Please Specify If Any Other Accreditation Certificates",
            errorMsg: "Any Other Accreditation Certificates",
        },
    ],
    [
        {
            label: "Do You Know Of Similar Hospitals In Your Network/Vicinity Who May Be Interested In Being Manyata Certified?",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "know_similar_hosp_network",
            required: true,
            valueType: "string",
            hide: false,
            placeholder: "Do You Know Of Similar Hospitals In Your Network/Vicinity Who May Be Interested In Being Manyata Certified?",
            errorMsg: "",
        },
        {
            label: "Can Our Team Contact You For The Further Details Regarding The Above Question?",
            type: "radio",
            option: [
                { name: 'Yes', value: '1' },
                { name: 'No', value: '2' },
            ],
            controllerName: "can_we_contact",
            required: true,
            valueType: "string",
            hide: true,
            placeholder: "Can Our Team Contact You For The Further Details Regarding The Above Question?",
            parent: { parentName: "know_similar_hosp_network", value: "1" },
            errorMsg: "",
        },
    ],
    // [
    //     {
    //         label: "Payment Status",
    //         type: "payment",
    //         controllerName: "paymentInformation",
    //         required: false,
    //         valueType: "string",
    //         hide: false,
    //     },
    // ]
]

export default [heading, inputDataList];

